export const DEFAULT_BIRD_SURVEY_FILTERS = {
  scientificName: '',
  taxonRank: '',
  startDate: '',
  endDate: '',
};

export const BIRD_SURVEY_COLUMNS = [
  { title: '物種學名', key: 'scientificName' },
  { title: '中文名', key: 'common_name_c' },
  { title: '中文別名', key: 'alternative_name_c' },
  { title: '同物異名', key: 'synonyms' },
  { title: '來源資料庫使用學名', key: 'sourceScientificName' },
  { title: '來源資料庫使用中文名', key: 'sourceVernacularName' },
  { title: '鑑定層級', key: 'taxonRank' },
  { title: '敏感層級', key: 'sensitiveCategory' },
  { title: '來源資料庫', key: 'rightsHolder' },
  { title: 'TaiCOL物種編號', key: 'taxonID' },
  { title: '調查起始日期', key: 'standardDate' },
  { title: '出現地', key: 'locality' },
  {
    title: '數量',
    key: 'organismQuantity',
    fallbackKey: 'standardOrganismQuantity',
  },
  { title: '數量單位', key: 'organismQuantityType' },
  { title: '記錄者', key: 'recordedBy' },
  { title: '空間參考系統', key: 'verbatimSRS' },
  { title: '經度', key: 'standardLongitude' },
  { title: '緯度', key: 'standardLatitude' },
  { title: '座標系統', key: 'verbatimCoordinateSystem' },
  { title: '座標誤差（公尺）', key: 'coordinateUncertaintyInMeters' },
  { title: '座標是否有模糊化', key: 'dataGeneralizations' },
  { title: '座標模糊化程度', key: 'coordinatePrecision' },
  { title: '紀錄類型', key: 'basisOfRecord' },
  { title: '資料集名稱', key: 'datasetName' },
  { title: '資料集聯絡人', key: 'resourceContacts' },
];

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
